<template>
  <b-select placeholder="Выберите комбо" expanded v-model="selectedCombo">
    <option v-for="combo in combos"
            :value="combo.id"

            :key="combo.id"
    >
      {{ combo.name }}
    </option>
  </b-select>
</template>

<script>
import comboRepository from "../../repository/comboRepository";

export default {
  props: ['combo'],
  data() {
    return {
      combos: [],
    }
  },
  computed: {
    selectedCombo: {
      get() {
        return this.combo;
      },
      set(value) {
        this.$emit('update:combo', value)
      }
    },
  },
  methods: {
    fetchData() {
      comboRepository.list()
          .then(({data}) => {
            this.combos = data;
          })
    },
  },
  mounted() {
    this.fetchData()
  }
}
</script>

<style scoped>

</style>